import React from 'react';
import { ExpandableCheckboxGroup } from '@youngcapital/component-library';
import * as yup from 'yup';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';

const LanguagesFieldset = ({ t, optionsData, getFieldProps }) => {
  const languages = optionsData.languages || [];
  const newLanguages = languages.map(lang => ({
    value: lang.id,
    label: lang.name
  }));

  return (
    <>
      <h3>{t('fieldset_languages.header')}</h3>
      <ExpandableCheckboxGroup
        {...getFieldProps('language_ids', props => {
          function setValues(values) {
            props.setTouched();
            props.setValue(values);
          }

          return {
            ...props,
            onBlur: setValues,
            onChange: setValues
          };
        })}
        limit={6}
        items={newLanguages}
        buttonLabel={t('fieldset_languages.show_more_button')}
      />
    </>
  );
};

LanguagesFieldset.type = 'languages';

LanguagesFieldset.propTypes = FIELDSET_PROPTYPES;

LanguagesFieldset.initialValues = () => ({
  language_ids: []
});

LanguagesFieldset.validationSchema = () => ({
  language_ids: yup.array().min(1)
});

export default asFieldset(LanguagesFieldset, { optionsData: true });
